import { render } from "./IndexWorkbench.vue?vue&type=template&id=76a1678a&scoped=true"
import script from "./IndexWorkbench.vue?vue&type=script&lang=js"
export * from "./IndexWorkbench.vue?vue&type=script&lang=js"

import "./IndexWorkbench.vue?vue&type=style&index=0&id=76a1678a&lang=scss"
import "./IndexWorkbench.vue?vue&type=style&index=1&id=76a1678a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a1678a"]])

export default __exports__